import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const InstalledBaseNodeAttributeTDAs = gql`
    query InstalledBaseNodeAttributeTDAs ($id: ID!) {
        installedBaseNodePropertyDefinition(id: $id) {
            id
            typeDefinitionAttributeList {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
